module.exports = __webpack_public_path__ + "img/pet_confidential.8a1f07e5.png";